import { menuGroup, menuItem } from "modules/helpers";

// components
import ErrorMessage from "./ErrorMessage.doc";

const components = [menuItem("<ErrorMessage/>", "error-message", ErrorMessage)];

// hooks
import UseApiAction from "./UseApiAction.doc";
import UseApiRequest from "./UseApiRequest.doc";

const hooks = [
  menuItem("useApiAction", "use-api-action", UseApiAction),
  menuItem("useApiRequest", "use-api-request", UseApiRequest),
];

// action creators
import ApiGet from "./ApiGet.doc";
import ApiPost from "./ApiPost.doc";
import ApiPut from "./ApiPut.doc";
import ApiPatch from "./ApiPatch.doc";
import ApiDelete from "./ApiDelete.doc";
import ApiRequest from "./ApiRequest.doc";
import ApiRequests from "./ApiRequests.doc";
import MockSuccess from "./MockSuccess.doc";
import MockError from "./MockError.doc";
import MockRequest from "./MockRequest.doc";

const actionCreators = [
  menuItem("apiGet", "api-get", ApiGet),
  menuItem("apiPost", "api-post", ApiPost),
  menuItem("apiPut", "api-put", ApiPut),
  menuItem("apiPatch", "api-patch", ApiPatch),
  menuItem("apiDelete", "api-delete", ApiDelete),
  menuItem("apiRequest", "api-request", ApiRequest),
  menuItem("apiRequests", "api-requests", ApiRequests),
  menuItem("mockSuccess", "mock-success", MockSuccess),
  menuItem("mockError", "mock-error", MockError),
  menuItem("mockRequest", "mock-request", MockRequest),
];

// reducer helpers
import RequestIsBusy from "./RequestIsBusy.doc";
import RequestIsSlow from "./RequestIsSlow.doc";
import RequestIsSuccess from "./RequestIsSuccess.doc";
import RequestIsAborted from "./RequestIsAborted.doc";
import RequestResponse from "./RequestResponse.doc";
import RequestError from "./RequestError.doc";
import RequestErrorHasCode from "./RequestErrorHasCode.doc";
import RequestStatus from "./RequestStatus.doc";
import RequestSentAt from "./RequestSentAt.doc";
import RequestReceivedAt from "./RequestReceivedAt.doc";
import RequestAbortedAt from "./RequestAbortedAt.doc";

const reducerHelpers = [
  menuItem("requestIsBusy", "request-is-busy", RequestIsBusy),
  menuItem("requestIsSlow", "request-is-slow", RequestIsSlow),
  menuItem("requestIsSuccess", "request-is-success", RequestIsSuccess),
  menuItem("requestIsAborted", "request-is-aborted", RequestIsAborted),
  menuItem("requestResponse", "request-response", RequestResponse),
  menuItem("requestError", "request-error", RequestError),
  menuItem("requestErrorHasCode", "request-error-has-code", RequestErrorHasCode),
  menuItem("requestStatus", "request-status", RequestStatus),
  menuItem("requestSentAt", "request-sent-at", RequestSentAt),
  menuItem("requestReceivedAt", "request-received-at", RequestReceivedAt),
  menuItem("requestAbortedAt", "request-aborted-at", RequestAbortedAt),
];

// configuration
import GetApiModuleOptions from "./GetApiModuleOptions.doc";
import GetApiOptions from "./GetApiOptions.doc";
import SetApiModuleOptions from "./SetApiModuleOptions.doc";
import SetApiOptions from "./SetApiOptions.doc";

const configuration = [
  menuItem(
    "getApiModuleOptions",
    "get-api-module-options",
    GetApiModuleOptions
  ),
  menuItem("getApiOptions", "get-api-options", GetApiOptions),
  menuItem(
    "setApiModuleOptions",
    "set-api-module-options",
    SetApiModuleOptions
  ),
  menuItem("setApiOptions", "set-api-options", SetApiOptions),
];

export default [
  menuGroup("Components", "components", components),
  menuGroup("Hooks", "hooks", hooks),
  menuGroup("Action Creators", "action-creators", actionCreators),
  menuGroup("Reducer Helpers", "reducer-helpers", reducerHelpers),
  menuGroup("Configuration", "configuration", configuration),
];
